import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, debounceTime, map } from 'rxjs';
import { ReactionId } from '../../timeline-item.types';
import { EmoticonReaction, EmoticonReactionDef } from './emoticon-reaction.type';

@Component({
    selector: 'tm-emoticon-reactions-button',
    templateUrl: './emoticon-reactions-button.component.html',
    styleUrls: ['./emoticon-reactions-button.component.scss'],
    imports: [
        CommonModule,
        AsyncPipe,
        MatTooltipModule,
        OverlayModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmoticonReactionsButtonComponent {
  
  // Subjects to manage overlay display
  buttonHovered = new BehaviorSubject(false);
  overlayHovered = new BehaviorSubject(false);
  isOpened$ = combineLatest([
    this.buttonHovered.pipe(debounceTime(100)),
    this.overlayHovered
  ]).pipe(
    map(([buttonHovered, overlayHovered]) => buttonHovered || overlayHovered)
  );

  overlayPositions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom'
    }, {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom'
    }
  ]

  @Input()
  value: EmoticonReaction;

  @Input()
  options: EmoticonReactionDef[];
  
  @Output()
  onReaction = new EventEmitter<ReactionId>();

  react(reaction?: ReactionId) {
    this.overlayHovered.next(false);

    if (reaction) {
      this.onReaction.next(reaction);
    }
  }
}